/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { useCallback } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var styles = css({
  maxHeight: 0,
  maxWidth: 0,
  position: 'absolute'
});
export var StopPropagationOld = function StopPropagationOld(_ref) {
  var children = _ref.children;
  var onClick = useCallback(function (e) {
    // Prevent click event inside modal from bubble up
    e.stopPropagation();
  }, []);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("span", {
      css: styles,
      onClick: onClick
    }, children)
  );
};